module.exports = __webpack_public_path__ + "static/media/hot51.f826e4a1.png";